// extracted by mini-css-extract-plugin
export var details = "_fa-0";
export var inspectorPopover = "_fa-1";